import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams, RequestOptions, ResponseContentType, Response } from '@angular/http';
import { Layer } from '../../models/layer.model';
import { Link } from '../../models/link.model';
import { Legend } from '../../models/legend.model';
import { Service } from '../../models/service.model';
import { Thematic } from '../../models/thematic.model';
import { LayerMenuBlock } from '../../models/layer-menu-block.model';
import { LayerMenuItem } from '../../models/layer-menu-item.model';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/toPromise';
import { environment } from 'environments/environment';

declare var xml2json;
declare var $;//jquery


@Injectable()
export class MapService {
  private getConfigURL = environment.BASE_URL + "/config.json";
  private getInfoConfigURL = environment.BASE_URL + "/info_config.xml";
  private printURL = environment.BASE_URL + "/printer";
  private config = null;
  private layers: Array<Layer>;
  private legends: Array<Legend>;
  private services: Array<Service>;
  private thematics: Array<Thematic>;
  private links: Array<Link> = [];
  private tocLayerMenu: Array<LayerMenuBlock>;

  private featureInfoPreview: any;
  private actualURL = new Subject<string>();
  private bboxPreview;
  private pixelsPreview;
  private coordinatesPreview;
  private featureInfo = new Subject<any>();
  private featureInfoConfig: Object;
  constructor(private http: Http) {
    this.layers = [];
    this.services = [];
    this.thematics = [];
    this.tocLayerMenu = [];
    this.legends = [];
  }

  public getConfiguration(): Promise<Object> {
    if (this.config == null) {
      return this.getConfigurationFromUrl().then(data => {
        this.config = data
        return data;
      });
    }
    return new Promise( () => {return this.config});
  }

  /*Getter of this.config (information returned from getConfigurationFromUrl)*/
  getConfigurationSaved(): Object {
    return this.config;
  }

  getConfigurationFromUrl(): Promise<Object> {

    return this.http.get(this.getConfigURL)
      .toPromise()
      .then(response => {
        this.config = response.json();
        if (response.json())
          return this.config
        else
          return {}
      })
      .catch(this.handleError);
  }

  getFeatureInfoConfig(): Promise<Object> {
    let parseXml = (xml) => {
      var dom = null;

      var parsed = false;
      try {
        dom = (new DOMParser()).parseFromString(xml, "text/xml");
        parsed = true;
      }
      catch (e) { dom = null; }

      return dom;
    }

    var headers = new Headers();
    headers.append('Accept', 'application/xml');

    return this.http.get(this.getInfoConfigURL, { headers: headers }).toPromise().then(resultats => {
      let textResultats = resultats.text();
      let xmlResultats = parseXml(textResultats);
      let json = xml2json(xmlResultats, " ");
      let parsedResultats = JSON.parse(json);
      this.featureInfoConfig = parsedResultats;

    }).catch(this.handleError);
  }

  /*
   Gets all layers */
  getLayers(): Layer[] {
    return this.layers;
  }
  /*
   Gets all layers */
  getLinks(): Link[] {
    if (this.links.length > 0) {
      return this.links;
    }
    else {
      this.parseLinks(this.config["links"]);
      return this.links;
    }
  }

  /*
   Gets all layers */
  getLegend(): Legend[] {
    if (this.legends.length > 0) {
      return this.legends;
    }
    else {
      this.parseLegend(this.config["legend"]);
      return this.legends;
    }
  }

  /* Filter layers by property */
  getLayersBy(property: string, value: any): Layer[] {
    let results = Array<Layer>();
    for (let index = 0; index < this.layers.length; index++) {
      let layer = this.layers[index];
      if (layer.hasOwnProperty(property) && layer[property] === value) {
        results.push(layer);
      }
    }
    return results;
  }


  /* Filter layers by property */
  getLinkBy(property: string, value: any): Link[] {
    let results = Array<Link>();
    for (let index = 0; index < this.layers.length; index++) {
      let link = this.links[index];
      if (link.hasOwnProperty(property) && link[property] === value) {
        results.push(link);
      }
    }
    return results;
  }


  /* Get all Services */
  getServices(): Array<Layer> {
    return this.layers;
  }

  /* Gets all layers */
  getTocLayerMenu(): Array<LayerMenuBlock> {
    return this.tocLayerMenu;
  }

  /* Filter services by property */
  getServicesBy(property: string, value: any): Service[] {
    let results = Array<Service>();
    for (let index = 0; index < this.services.length; index++) {
      let service = this.services[index];
      if (service.hasOwnProperty(property) && service[property] === value) {
        results.push(service);
      }
    }
    return results;
  }


  /* Gets all layers */
  getThematics(): Array<Thematic> {
    return this.thematics;
  }
  parseLayers(obj: Object[]) {
    let biggestLayerOrder = -1;
    this.layers = new Array<Layer>();
    for (let index = 0; index < obj.length; index++) {
      let layerObj = obj[index];
      if (typeof (layerObj["serviceid"]) !== "undefined" && typeof (layerObj["layer"]) !== "undefined" && typeof (layerObj["id"]) !== "undefined") {//totalment imprescindible.
        let layer = new Layer();
        layer.active = layerObj["active"];
        layer.id = layerObj["id"];
        layer.name = layerObj["layer"];
        layer.type = layerObj["type"];
        layer.serviceId = layerObj["serviceid"];
        layer.title = layerObj["title"];
        layer.order = layerObj["order"];
        layer.opacity = layerObj["opacity"];
        this.layers.push(layer);
      } else {
        console.warn("El següent layer no te la informació correcte >> ", layerObj);
      }
    }
  }

  parseThematics(obj: Object[]): Thematic[] {
    this.thematics = new Array<Thematic>();
    for (let index = 0; index < obj.length; index++) {
      let themObj = obj[index];
      if (typeof (themObj["id"]) !== "undefined" && typeof (themObj["layers"]) !== "undefined") {//totalment imprescindible.

        let them = new Thematic();
        them.id = themObj["id"];
        them.layersId = themObj["layers"];
        them.name = themObj["name"];
        them.thumbnail = themObj["thumbnail"];
        them.state = "unactive";
        if (index == 0) {
          them.state = "active";
        }
        them.source = themObj.hasOwnProperty("source") && themObj["source"] !== null && themObj["source"] !== "" ? themObj["source"] : "";
        this.thematics.push(them);
      } else {
        console.warn("El següent temàtic no te la informació correcte >> ", themObj);
      }
    }
    return this.thematics;
  }

  parseServices(obj: Object[]) {
    this.services = new Array<Service>();
    for (let index = 0; index < obj.length; index++) {
      let serviceObj = obj[index];
      if (typeof (serviceObj["id"]) !== "undefined" && typeof (serviceObj["url"]) !== "undefined") {
        let service = new Service();
        service.id = serviceObj["id"];
        service.url = serviceObj["url"];
        service.version = serviceObj["version"];
        service.tiled = serviceObj["tiled"];
        service.transparent = serviceObj["transparent"];
        service.format = serviceObj["format"];
        let layersFromService = this.getLayersBy("serviceId", service.id);
        service.layers = layersFromService;
        this.services.push(service);
      } else {
        console.warn("El següent service no te la informació correcte >> ", serviceObj);
      }
    }
  }

  parseLinks(obj: Object[]) {
    this.links = new Array<Link>();
    for (let index = 0; index < obj.length; index++) {
      let linkObj = obj[index];
      if (typeof (linkObj["name"]) !== "undefined" && typeof (linkObj["href"]) !== "undefined") {
        let link = new Link();
        link.name = linkObj["name"];
        link.href = linkObj["href"];
        this.links.push(link);
      } else {
        console.warn("El següent link no te la informació correcte >> ", linkObj);
      }
    }
  }

  parseLegend(obj: Object[]) {
    this.legends = new Array<Legend>();
    for (let index = 0; index < obj.length; index++) {
      let legendObj = obj[index];
      if (typeof (legendObj["name"]) !== "undefined" && typeof (legendObj["href"]) !== "undefined") {
        let legend = new Legend();
        legend.name = legendObj["name"];
        legend.href = legendObj["href"];
        this.legends.push(legend);
      } else {
        console.warn("El següent link no te la informació correcte >> ", legendObj);
      }
    }
  }

  parseTocLayerMenu(obj: Object[], defaultBlockArrowClasses: Object): Array<LayerMenuBlock> {
    this.tocLayerMenu = new Array<LayerMenuBlock>();
    for (let index = 0; index < obj.length; index++) {
      let tocObj = obj[index];
      if (typeof (tocObj["blockcontent"]) !== "undefined") {
        let layerMenuBlock = new LayerMenuBlock();
        layerMenuBlock.blockId = tocObj["blockid"];
        layerMenuBlock.blockName = tocObj["blockname"];
        layerMenuBlock.desplegat = false;
        layerMenuBlock.blockContent = [];
        layerMenuBlock.arrowClasses = defaultBlockArrowClasses;
        layerMenuBlock.capesVisibles = 0;
        for (let indexContent = 0; indexContent < tocObj["blockcontent"].length; indexContent++) {
          let content = tocObj["blockcontent"][indexContent];
          let tocItemObj = new LayerMenuItem();
          tocItemObj.layerId = content["layerid"];
          tocItemObj.title = content["title"];
          tocItemObj.legend = content["legend"];
          layerMenuBlock.blockContent.push(tocItemObj);
        }
        this.tocLayerMenu.push(layerMenuBlock);
      }
      else {
        console.warn("El següent toc item no te la informació correcte >> ", tocObj);
      }
    }
    return this.tocLayerMenu;
  }

  private getFilenameFromResponse(response): string {
    if (!response) return "";
    let header:string = response.headers.get("Content-Disposition");
    if (!header) return "";
    return header.split(";") // ['charset="utf-8"', 'filename="printed.pdf"']
      .filter(s => s.includes("filename"))[0] // 'filename="printed.pdf"'
      .split("=")[1] // '"printed.pdf"'
      .replace(/^"?(.+?)"?$/, '$1') // 'printed.pdf' (removed optional " at the start and/or end of the filename)
  }

  private getTypeFromResponse(response: Response): string {
    if (!response) return "";
    let header: string = response.headers.get("Content-Type");
    if (!header) return "";
    return header.split(";")
      .find(s =>
        s == 'application/pdf' ||
        s == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      );
  }

  doPrint(printParams: any): Promise<Object> {
    let urlSearchParams = new URLSearchParams();
    for (let paramName in printParams) {
      urlSearchParams.append(paramName, printParams[paramName]);
    }
    let body = urlSearchParams.toString()
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' });
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    return this.http.post(this.printURL, body, options)
      .toPromise()
      .then(response => {
        console.log(response);
        let filename = this.getFilenameFromResponse(response)
        let type = this.getTypeFromResponse(response);
        return [new Blob([response.blob()], { type: type }), filename]; // [Blob, string]
      })
      .catch(this.handleError);
  }

  getPreviewInfoFromPoint(projection, bbox, pixels, coordinates): Promise<any> {//boundingBox:[number,number,number,number]s
    try {
      this.coordinatesPreview = coordinates;
      this.bboxPreview = bbox;
      this.pixelsPreview = pixels;
      this.getFeatureInfo(projection);
      let url = this.getConfigurationSaved()["featureinfo"].previewURL + "&EXCEPTIONS=application%2Fvnd.ogc.se_xml&BBOX=" + bbox[0] + "," + bbox[1] + "," + bbox[2] + "," + bbox[3] + "&FEATURE_COUNT=50&WIDTH=101&HEIGHT=101&format=image%2Fpng&styles=&version=1.1.1&x=" + pixels[0] + "&y=" + pixels[1];
      return this.http.get(url)
        .toPromise()
        .then(response => {
          this.featureInfoPreview = response.json();
          if (response.json())
            return this.featureInfoPreview
          else
            return {}
        })
        .catch(this.handleError);
    } catch (e) {
      console.error('Comprovar que al config.json hi hagi definit el valor previewURL', e); // for demo purposes only
    }
  }

  getFeatureInfo(projection): void {
    $("#infoResultsHTML").html('<i id="info-panel-loading-icon"></i>');
    let layerNames = this.featureInfoConfig["main"]["wms_layernames"];
    let wmsProperties = [];
    this.featureInfoConfig["main"]["layers"]["layer"].forEach(function(obj, index) {
      wmsProperties.push("(" + obj.wms_fields + ")");
    });
    let properties = wmsProperties.join("");
    let url = environment.BASE_URL +
      "/getmap?" +
      "REQUEST=GetFeatureInfo&EXCEPTIONS=application%2Fvnd.ogc.se_xml&BBOX=" + this.bboxPreview[0] + "," + this.bboxPreview[1] + "," + this.bboxPreview[2] + "," + this.bboxPreview[3] +
      "&SERVICE=WMS&INFO_FORMAT=application%2Fvnd.ogc.gml&QUERY_LAYERS=" + layerNames +
      "&FEATURE_COUNT=50&Layers=" + layerNames +
      "&propertyName=" + properties +
      "&WIDTH=101&HEIGHT=101&format=image%2Fpng&styles=&srs=" + projection + "&version=1.1.1&x=" + this.pixelsPreview[0] + "&y=" + this.pixelsPreview[1];
    this.http.get(url)
      .toPromise()
      .then(response => {
        this.featureInfo.next(response.text());
      })
      .catch(this.handleError);
  }


  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

  setUrl(urlActual: string) {
    this.actualURL.next(urlActual);
  }

  getUrl(): Observable<string> {
    return this.actualURL.asObservable();
  }

  getPixelsInfo(): any {
    return this.pixelsPreview;
  }
  getCoordinatesForInfo(): any {
    return this.coordinatesPreview;
  }
  getFeatureInfoPanel(): Observable<any> {
    return this.featureInfo.asObservable();
  }
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/services/map/map.service.ts